module.exports = __webpack_public_path__ + "static/media/Prodor.5a69a449.jpg";